import { Button, Form, Input } from 'antd';
import React, { useEffect } from 'react';
import { useVideoCat } from './VideoCatState';
import { useForm } from 'antd/es/form/Form';

function Edit() {
    let { ed, editCat } = useVideoCat()
    let [frm] = useForm()
    useEffect(() => {
        frm.setFieldsValue(ed)
    }, [ed])
    return (
        <>
            <Form
                form={frm}
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={(v) => { editCat(v) }}
                autoComplete="off"
            >
                <Form.Item
                    name="id"
                    hidden={true}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Kategoriya nomi"
                    name="title"
                    rules={[
                        {
                            required: true,
                            message: "To'ldirish majburiy",
                        },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Saqlash
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default Edit;